export default () => {
  function initMap() {
    window.map = new google.maps.Map(
      document.getElementById('.js-square-map'),
      {
        // center: {lat: -34.397, lng: 150.644},
        zoom: 8
      }
    );
  }

  window.initMap = initMap;
};



// WEBPACK FOOTER //
// ./assets/scripts/components/square-map.js